// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"76f9d31b","111":"39b0bac1","136":"bf72ec42","171":"9a24d0ab","250":"ccda1461","431":"a128994c","442":"e58f7993","625":"3dc4e688","864":"d42b06fc","935":"c1e8e72b","955":"674e4e43","966":"f3cd1bea","996":"7f3e9a2c"}[chunkId] + ".chunk.js";
};